import React from "react";
import {
  StoryblokBenefit,
  StoryblokInformativeSection,
} from "../../../interfaces/Storyblok/StoryblokInformativeSection.interface";
import Image from "../../atoms/Image/Image.atom";

const InformativeSection: React.FC<StoryblokInformativeSection> = ({ description, benefits }) => {
  return (
    <section className="container mx-auto py-12 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
        {description && (
          <p className="text-xl leading-relaxed text-Body whitespace-pre-line">{description}</p>
        )}

        {!!benefits?.length && (
          <ul className="space-y-6 md:space-y-8">
            {benefits.map((benefit: StoryblokBenefit) => (
              <li key={benefit._uid} className="flex items-start gap-4 md:gap-5">
                <div className="w-10 h-10 shrink-0 md:w-12 md:h-12">
                  <Image image={benefit.icon} objectFit="contain" isDecorative />
                </div>
                <p className="flex-1 self-center text-xl font-bold text-Body">{benefit.description}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};

export default InformativeSection;
